import { useEffect } from "react";
import { useRecoilState } from "recoil";

// import { Alert } from "@mui/material";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Stack from "@mui/material/Stack";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Logo } from "@/components/atoms/logo";

import { settingsState } from "@/state/settings";

// import TriggerButton from "./OpenSideBarButton"; //temp
import { ThreadHistory } from "./threadHistory";
// import { useAuth } from "@/client/api";
// import { useConfig } from "@/client/useConfig";
import { SidePaths } from "./sidePaths";

// import ThemeToggle from "@/components/atoms/buttons/ThemeToggle";

const DRAWER_WIDTH = 260;

const SideBar = () => {
  // const user = useAuth();
  const isMobile = useMediaQuery("(max-width:66rem)");

  const [settings, setSettings] = useRecoilState(settingsState);
  // const { config } = useConfig();
  // const enableHistory = !!user.accessToken && !!config?.dataPersistence;

  useEffect(() => {
    if (isMobile) {
      setSideBarOpen(false);
    }
  }, []);

  const setSideBarOpen = (open: boolean) =>
    setSettings((prev) => ({ ...prev, isSideBarOpen: open }));

  return (
    <Box display="flex" position="relative">
      <Drawer
        className="sidebar-drawer"
        anchor="left"
        open={isMobile ? settings.isSideBarOpen : true}
        variant={isMobile ? "temporary" : "persistent"}
        transitionDuration={0}
        hideBackdrop={!isMobile}
        onClose={() => setSideBarOpen(false)}
        sx={{
          width:
            !settings.isSideBarOpen && isMobile
              ? 0
              : settings.isSideBarOpen
              ? DRAWER_WIDTH
              : 65,
          transition: "width 0.3s ease", // <- transition for the Drawer wrapper itself
          "& .MuiDrawer-paper": {
            width:
              !settings.isSideBarOpen && isMobile
                ? 0
                : settings.isSideBarOpen
                ? DRAWER_WIDTH
                : 65,
            transition: "width 0.3s ease", // <- transition for the Drawer paper (the actual visible part)
            overflowX: "hidden", // prevents horizontal scrollbar
            position: "inherit",
            gap: 1,
            display: "flex",
            flexDirection: "column",
            padding: "0px 4px",
            backgroundImage: "none",
            backgroundColor: (theme) => theme.palette.background.default,
            borderRight: (theme) =>
              theme.palette.mode === "dark" ? "none" : "none",
            px: 1,
            boxSizing: "border-box",
            // boxShadow: (theme) =>
            //   theme.palette.mode === "dark"
            //     ? "0px 4px 20px 0px rgba(0, 0, 0, 0.20)"
            //     : "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
          },
        }}
      >
        <Stack
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            height: "45px",
            my: 2,
          }}
        >
          {settings.isSideBarOpen ? (
            <Logo style={{ maxHeight: "48px" }} />
          ) : (
            <Logo style={{ maxHeight: "60px" }} lite={true} />
          )}
        </Stack>

        <SidePaths />

        {/* {isMobile && settings.isChatHistoryOpen && <ThreadHistory />} */}
        {/* <ThreadHistory /> */}
        {settings.isSideBarOpen && <ThreadHistory />}
        {/* Push ThemeToggle to bottom */}
      </Drawer>

      {/* {!isMobile ? (
        <Box
          position="absolute"
          sx={{
            top: "50%",
            transform: "translateY(-100%)",
            right: -30,
            zIndex: 10,
          }}
        >
          <TriggerButton
            onClick={() => setSideBarOpen(!settings.isSideBarOpen)}
            open={settings.isSideBarOpen}
          />
        </Box>
      ) : null} */}
    </Box>
  );
};

export { SideBar };
